<template><div class="input-group-append"><slot /></div></template>
<script>export default { name: "SbInputGroupAppend" };</script>
